// extracted by mini-css-extract-plugin
export default {"container":"lotOption_container__DTx6P","stock":"lotOption_stock__E+4t0","noStock":"lotOption_noStock__h6LZd"};